import React, { useRef, useEffect } from "react";
import { Loader } from "semantic-ui-react";

import { useV2fetchChatSessionByIdQuery } from "./chatSessionApiSlice";


const V2ChatSessionDetail = (props) => {
    const messageRef = useRef(null);
    const setDetailedChatSession = props.set_detailed_chat_session;

    const {
        data: chatSession,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useV2fetchChatSessionByIdQuery(props.chat_session_id);

    useEffect(() => {
        if (isSuccess && setDetailedChatSession) {
          setDetailedChatSession(chatSession);
        }
      }, [isSuccess, chatSession, setDetailedChatSession]);

    if (isLoading) {
        return <Loader active />;
    }

    if (isError) return null;

    let content;

    content = (
        // <Segment raised className="scrollable-right-pane">
        <div ref={messageRef}>
            {chatSession.chatlog_set.map((message, index) => (
                <div
                    id={message.id}
                    className={`message-row ${message.speaker === "H" ? "sent" : "received"
                        }`}
                >
                    <div
                        className={`message-bubble ${message.speaker === "H" ? "sent" : "received"
                            }`}
                    >
                        <p className="message-text">{message.utterance}</p>
                    </div>
                </div>
            ))}
        </div>
    );

    return content;
}

export default V2ChatSessionDetail